import {Component, Input, OnInit} from '@angular/core';
import {VetClinic} from "../../models/vet-clinic.model";
import {UserService} from "../../providers/user.service";
import {AppStateService} from "../../providers/app-state.service";
import {ModalController} from "@ionic/angular";
import {CommonUtils} from "../../utils/common";

@Component({
  selector: 'app-choose-user-clinic-component',
  templateUrl: './choose-user-clinic.component.html',
  styleUrls: ['./choose-user-clinic.component.scss'],
})
export class ChooseUserClinicComponent implements OnInit {
  vetClinics: VetClinic[];
  @Input() uuid: string;
  isLoading: boolean = true;
  nameCollisionExits = false;

  constructor(private userService: UserService, private appStateService: AppStateService,
              private modalController: ModalController,
              private commonUtils: CommonUtils) {
  }

  ngOnInit() {
    this.appStateService.updateIsBusySubject(true);
    this.userService.getUserClinics(this.uuid).subscribe(clinics => {
      this.vetClinics = clinics;
      this.isLoading = false;
      this.appStateService.updateIsBusySubject(false);
      this.nameCollisionExits = this.checkNameCollisionExits();
    })
  }

  checkNameCollisionExits() {
    if (this.vetClinics.length > 1) {
      const names = this.vetClinics.map(c => c.clinicName.toLowerCase());
      return new Set(names).size !== names.length;
    }
  }

  onSelect(clinic: VetClinic) {
    this.modalController.dismiss({clinic, collision: this.nameCollisionExits}, );
  }

  onClose() {
    this.modalController.dismiss(null);
  }

  getClinicName(clinic: VetClinic) {
    return this.nameCollisionExits ? this.commonUtils.getClinicNameWithAddress(clinic) : clinic.clinicName;
  }
}
